const surveyBasePrefix = `/survey`;
export const survey = {
  getSurvey: (surveyId: string, clientId: string) => `${surveyBasePrefix}/${surveyId}/${clientId}`,
  postSurvey: (surveyId: string, clientId: string) => `${surveyBasePrefix}/${surveyId}/${clientId}`,
  getImgae: (surveyId: string, clientId: string) => `${surveyBasePrefix}/image/${surveyId}/${clientId}`,
};
